import {
    ButtonClickObject,
    GoogleOrder,
    HgsCart,
    HgsCartItem,
    HgsProductItem,
} from "../types";

function trackEvent(eventType: string, info: any) {
  if (typeof gtag !== "undefined") {
    gtag("event", eventType, info);
  } else {
    console.log(eventType, info);
  }
  
}

export type PWATrackingObject = {
    eventCategory: string;
    eventAction: string;
    nonInteraction: boolean;
};

export function triggerViewItemEvent(itemsObject: HgsProductItem) {
  trackEvent("view_item", {
        currency: "USD",
        value: itemsObject.price,
        items: [itemsObject],
    });
}

export function triggerAddToCartEvent(itemsObject: HgsCartItem) {
    const totalPrice = Math.round(itemsObject.price * itemsObject.quantity * 100) / 100;
    trackEvent("add_to_cart", {
        currency: "USD",
        value: totalPrice,
        items: [itemsObject],
    });
}

export function triggerPWAInstallPrompted() {
    trackEvent("pwa-prompt", <PWATrackingObject>{
        eventCategory: "pwa-install",
        eventAction: "promo-shown",
        nonInteraction: true,
    });
}

export function triggerPWAInstalled() {
    if (document.visibilityState !== "visible") return;
    trackEvent("pwa-installed", <PWATrackingObject>{
        eventCategory: "pwa-install",
        eventAction: "app-installed",
        nonInteraction: false,
    });
}

export function triggerBeginCheckout(cart: HgsCart) {
    trackEvent("begin_checkout", {
        currency: "USD",
        value: cart.total_price,
        items: cart.items,
    });
}

export function triggerButtonClickEvent(e: ButtonClickObject) {
    trackEvent("button_click", e);
}

export function triggerCheckoutCompleteEvent(order: GoogleOrder) {
    trackEvent("purchase", order);
}
